import React, {useEffect, useContext} from 'react';
import {Button, Card, Col, Row} from "antd";
import {withRouter, useHistory, Link} from 'react-router-dom';
import {API} from "../api";
import { DimaContext } from '../DimaContext';
import { fetchUserPreferences } from '../utils/util';

function Login() {
    const history = useHistory();
    const dimaContext = useContext(DimaContext);

    useEffect(() => {
        let params = new URLSearchParams(window.location.search);
        if (params.has("user_auth_token") && params.has("user_id") && params.has("auth_token_expiry") && params.has("user_role")) {
            // add user auth creds to localstorage
            window.localStorage.setItem("user_auth_token", params.get('user_auth_token'))
            window.localStorage.setItem("user_id", params.get('user_id'))
            window.localStorage.setItem("auth_token_expiry", params.get('auth_token_expiry'))
            window.localStorage.setItem("user_role", params.get('user_role'))
            window.localStorage.setItem("user_name", params.get('user_name'))
            window.localStorage.setItem("user_email", params.get('user_email'))
            handleHistoryChange(params);
        }
    }, [history])

    const handleLogin = async () => {
        let res = await API.get('/login');
        window.location.assign(res.data.url);
    }

    const handleHistoryChange = async (params) => {
        let newUserData = {}
        if (process.env.REACT_APP_FEATURE_PERMISSIONS_V2) {
            const response = await API.get(`/user/${params.get('user_id')}/permissions`);
            if (response.status === 200) {
                newUserData = { ...response.data};
            }
        }

        const userPreferencesList = await fetchUserPreferences();
        newUserData.preferences = userPreferencesList;
        newUserData.loaded = true 
    
        dimaContext.setUserData(newUserData);

        // Routing to client list page
        history.push('/');
    }

    return (
        <Row justify="center" align="middle">
            <Card title="DIMA - Data Ingest & Mapping Admin" style={{minWidth: "500px"}}>
                {/*<Row gutter={[16, 16]} style={{marginBottom: 20}}>*/}
                {/*    <Input addonBefore="Username:" disabled={true} />*/}
                {/*</Row>*/}
                {/*<Row gutter={[16, 16]} style={{marginBottom: 20}}>*/}
                {/*    <Input addonBefore="Password:" disabled={true} />*/}
                {/*</Row>*/}
                {/*<Row gutter={[16, 16]} style={{marginBottom: 20}}>*/}
                {/*    <Button disabled onClick={handleLogin} type="primary" style={{width: "100%", height: "40px"}}>Sign In</Button>*/}
                {/*</Row>*/}
                <Row style={{marginBottom: 5}}>
                    <Col span={24}>
                        <Button onClick={handleLogin} type="primary" style={{height: "40px", width: "100%"}}>
                            <b>Sign In (Okta)</b>
                        </Button>
                    </Col>
                </Row>
                <Row justify="end">
                    <Link
                        to='#'
                        onClick={(e) => {
                            window.location = 'mailto:data-app-eng@1up.health?subject=Request Access to Mapping Tool&body=Please enter the following information:%0D%0AYour Full Name:%0D%0AYour 1Up Email: %0D%0A%0D%0AWe will get back to you soon, thanks!';
                            e.preventDefault();
                        }}>
                        Request access
                    </Link>
                </Row>
            </Card>
        </Row>
    );
}

export default withRouter(Login);

